<!-- <template>
  <div align="left">
    <v-container fluid class="pa-0 login-bg LoginImage">
      <Snackbar :SnackBarComponent="SnackBarComponent" />
      <v-layout align-center justify-center>
        <v-row no-gutters justify="center">
          <v-col
            cols="12"
            class="py-2 overlayColor d-flex flex-column"
            v-if="$vuetify.display.mdAndUp"
          >
            <div align="left" class="mt-16">
              <v-img
                src="@/assets/MIHS_logo/LogoBackground.png"
                width="180px"
              />
            </div>
            <div class="d-flex text-white fontsize65px mt-4">MAKE IT</div>
            <div class="mt-n5 text-white fontsize65px">HOME SAFE</div>
            <div class="fontsize25px text-white">
              Real-time remote driver identification for safer traffic stops
            </div>

            <v-card
              class="elevation-0"
              color="transparent"
              :class="$vuetify.display.mdAndUp ? 'mt-6' : 'mt-6'"
              align="center"
            >
              <div class="noOpacity mt-16">
                <v-img
                  v-if="$vuetify.display.smAndDown"
                  src="@/assets/MIHS_logo/LogoBackground.png"
                  width="80px"
                />
                <v-card-title>
                  <v-row no-gutters>
                    <v-col cols="12" class="py-0" align="center">
                      <div class="pt-2 text-white fontsize35px">
                        {{ currentTitle }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="py-0">
                  <v-window v-model="loginStepper" class="px-2">
                    <v-window-item :value="1">
                      <v-card-text class="mt-6">
                        <v-form ref="form" @submit.prevent lazy-validation>
                          <v-text-field
                            variant="outlined"
                            class="borderRadius LoginPage field_height fontsize16px text-white"
                            @keydown.space="preventLeadingSpace"
                            @keydown.enter="ValidateSignUpForm()"
                            v-model="Login.EmailID"
                            height="60px"
                            bg-color="transparent"
                            placeholder="Email"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="25px" color="#a0add8"
                                >mdi-email-outline</v-icon
                              >
                            </template>
                          </v-text-field>
                        </v-form>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn
                          block
                          :loading="loading"
                          tile
                          class="BTNradius gradient-bg fontsize18px"
                          color="primary"
                          height="60px"
                          @click="ValidateSignUpForm()"
                          >Login</v-btn
                        >
                      </v-card-actions>
                      <div
                        class="fontsize18px font-weight-bold text-white mt-16"
                      >
                        <span>Don't have an account?</span>
                        <v-btn
                          size="large"
                          text
                          color="#a0add8"
                          class="text-capitalize mt-n1 ml-2"
                          @click="loginStepper = 5"
                          >Sign up</v-btn
                        >
                      </div>
                    </v-window-item>

                    <v-window-item :value="4">
                      <v-card-text class="mt-8">
                        <v-form ref="formConfirmOTP">
                          <div class="text-center text-white">
                            Enter the OTP Sent to
                            <span class="font-weight-bold">{{
                              this.$store.getters.get_user_email
                            }}</span>
                          </div>

                          <v-otp-input
                            ref="otpInput"
                            length="6"
                            required
                            size="large"
                            :rules="[(v) => !!v || 'OTP is required']"
                            v-model="ConfirmOTP"
                            @finish="ValidateEnteredOTP()"
                            class="mt-4 text-white font-weight-bold"
                          >
                          </v-otp-input>
                        </v-form>
                      </v-card-text>
                      <v-card-actions class="mt-2">
                        <v-btn
                          color="white"
                          class="fontStyle borderRadius"
                          size="small"
                          dark
                          variant="outlined"
                          @click="loginStepper = 1"
                          >Change Email</v-btn
                        >
                        <v-spacer />
                        <v-btn
                          color="white"
                          size="small"
                          variant="outlined"
                          dark
                          @click="ValidateSignUpForm()"
                          ><v-icon size="small">mdi-refresh</v-icon>Resend
                          OTP</v-btn
                        >
                      </v-card-actions>
                      <v-card-actions class="mt-10">
                        <v-btn
                          color="primary"
                          class="fontStyle BTNradius"
                          block
                          dark
                          variant="elevated"
                          height="60px"
                          :loading="loadingLogin"
                          @click="ValidateEnteredOTP()"
                          >login</v-btn
                        >
                      </v-card-actions>
                    </v-window-item>
                    <v-window-item :value="5">
                      <v-card-text class="pt-5">
                        <v-form ref="formSignUp">
                          <div
                            v-if="!imgSrc"
                            style="position: relative; display: inline-block"
                          >
                            <v-btn
                              rounded
                              size="x-small"
                              style="
                                position: absolute;
                                top: 0;
                                right: 0;
                                transform: translate(-30%, 10%);
                                z-index: 2;
                              "
                              color="green"
                              @click.stop="checkImagePresent"
                            >
                              <v-icon color="white">mdi-pencil</v-icon>
                            </v-btn>

                            <v-icon size="150" color="white">
                              mdi-account-circle
                            </v-icon>

                            <input
                              type="file"
                              accept="image/*"
                              id="CategoryImg"
                              hidden
                              ref="image-upload-input"
                              @change="handleClick"
                            />
                          </div>

                          <div
                            v-else
                            style="position: relative; display: inline-block"
                          >
                            <v-avatar
                              size="150"
                              rounded="25"
                              style="
                                position: relative;
                                border: 2px solid white;
                              "
                              class="CursorPointor"
                            >
                              <v-img
                                contain
                                :src="imgSrc"
                                style="position: relative"
                              />
                            </v-avatar>
                            <v-btn
                              fab
                              style="
                                position: absolute;
                                top: 0;
                                right: 0;
                                transform: translate(-30%, 10%);
                                z-index: 2;
                              "
                              top
                              size="small"
                              color="green"
                              class="mx-n6"
                              @click="checkImagePresent"
                            >
                              <v-icon color="white" size="large"
                                >mdi-pencil</v-icon
                              >
                            </v-btn>
                            <input
                              type="file"
                              accept="image/*"
                              id="CategoryImg"
                              hidden
                              ref="image-upload-input"
                              @change="handleClick"
                            />
                          </div>
                          <v-text-field
                            density="compact"
                            variant="outlined"
                            v-model="sign_up.user_name"
                            :rules="[(v) => !!v || '']"
                            height="60px"
                            class="borderRadius LoginPage field_height fontsize12px mt-5 text-white"
                            placeholder="Name"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="25px" color="#a0add8" class="mt-2"
                                >mdi-account-outline</v-icon
                              >
                            </template>
                          </v-text-field>
                          <v-text-field
                            density="compact"
                            variant="outlined"
                            v-model="sign_up.user_email_id"
                            :rules="[
                              (v) => !!v || '',
                              (v) => /.+@.+/.test(v) || 'Email Must Be Valid',
                            ]"
                            height="60px"
                            class="borderRadius LoginPage field_height fontsize12px text-white"
                            placeholder="Email"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="25px" color="#a0add8" class="mt-2"
                                >mdi-email-outline</v-icon
                              >
                            </template>
                          </v-text-field>
                        </v-form>
                      </v-card-text>
                      <v-card-actions class="mx-2">
                        <v-btn
                          tile
                          size="small"
                          block
                          color="primary"
                          class="BTNradius gradient-bg fontsize18px"
                          height="60px"
                          @click="validateSignUpMethod()"
                          :loading="loading"
                          >Sign Up</v-btn
                        >
                      </v-card-actions>
                      <v-btn
                        text
                        color="white"
                        class="fontsize18px borderRadius text-capitalize mt-3"
                        size="small"
                        @click="loginStepper = 1"
                        ><u>Back To Sign In</u></v-btn
                      >
                    </v-window-item>
                  </v-window>
                </v-card-text>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </div>
</template> -->
<template>
  <v-container
    fluid
    :class="
      $vuetify.display.mdAndUp ? 'login-bg pa-0' : 'loginsmall_screen pa-0'
    "
  >
    <Snackbar :SnackBarComponent="SnackBarComponent" />

    <div class="login-wrapper mx-3">
      <v-card class="login-card" elevation="0">
        <div class="d-flex justify-center">
          <v-img max-width="80" src="@/assets/MIHS_logo/MIHS_Image.png"></v-img>
        </div>
        <div class="text-center mb-6">
          <h2 class="title-text mt-2">MAKE IT HOME SAFE</h2>
        </div>

        <v-window v-model="loginStepper" :touch="false">
          <v-window-item :value="1">
            <label class="input-label">Email *</label>
            <v-form ref="form" @submit.prevent lazy-validation>
              <v-text-field
                v-model="Login.EmailID"
                @keydown.space="preventLeadingSpace"
                @keydown.enter="ValidateSignUpForm()"
                variant="outlined"
                density="compact"
                bg-color="#f9fafb"
                placeholder="officer@department.gov"
              >
                <template #prepend-inner>
                  <v-icon>mdi-email-outline</v-icon>
                </template>
              </v-text-field>
            </v-form>
            <v-btn
              block
              height="38"
              class="login-btn mt-4"
              :loading="loading"
              @click="ValidateSignUpForm()"
            >
              Verify
            </v-btn>

            <div class="fontsize12px mt-16 text-center">
              <span>Don't have access?</span>
              <v-btn
                size="small"
                variant="text"
                color="#1f3a68"
                class="text-capitalize ml-2 elevation-0"
                @click="loginStepper = 5"
                >Sign up</v-btn
              >
            </div>
          </v-window-item>

          <v-window-item :value="4">
            <p class="text-center otp-text mb-3">
              Enter verification code sent to
              <strong>{{ $store.getters.get_user_email }}</strong>
            </p>
            <v-form ref="formConfirmOTP">
              <v-otp-input
                ref="otpInput"
                v-model="ConfirmOTP"
                length="6"
                class="mb-4"
                @finish="ValidateEnteredOTP"
              />
            </v-form>
            <v-btn
              block
              height="48"
              class="login-btn"
              :loading="loadingLogin"
              @click="ValidateEnteredOTP"
            >
              VERIFY & SIGN IN
            </v-btn>

            <div class="text-center mt-3">
              <span class="link" @click="loginStepper = 1">Change Email</span>
            </div>
          </v-window-item>

          <v-window-item :value="5">
            <v-form ref="formSignUp">
              <v-text-field
                v-model="sign_up.user_name"
                variant="outlined"
                density="compact"
                bg-color="#f9fafb"
                placeholder="Full Name"
              >
                <template #prepend-inner>
                  <v-icon>mdi-account-outline</v-icon>
                </template>
              </v-text-field>

              <v-text-field
                v-model="sign_up.user_email_id"
                variant="outlined"
                density="compact"
                bg-color="#f9fafb"
                placeholder="Email Address"
              >
                <template #prepend-inner>
                  <v-icon>mdi-email-outline</v-icon>
                </template>
              </v-text-field>
            </v-form>
            <v-btn
              block
              height="48"
              class="login-btn mt-4"
              :loading="loading"
              @click="validateSignUpMethod"
            >
              CREATE ACCOUNT
            </v-btn>

            <div class="text-center mt-3">
              <span class="link" @click="loginStepper = 1">
                ← Back to Sign In
              </span>
            </div>
          </v-window-item>
        </v-window>
      </v-card>
    </div>

    <div class="footer-text">
      © 2026 Make It Home Safe · All Rights Reserved
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import Snackbar from "@/components/Extras/Snackbar.vue";
import { GenerateUploadURL } from "@/mixins/UploadImageURL.js";
import { signIn, confirmSignIn, signOut } from "aws-amplify/auth";

export default {
  components: {
    Snackbar,
  },
  mixins: [GenerateUploadURL],
  data: () => ({
    imgSrc: "",
    OTPEmail: "",
    ConfirmOTP: "",
    ConfirmNewPassword: "",

    loadingLogin: false,
    loading: false,
    isPwdNew: false,
    isPwdLogin: false,
    rememberme: false,
    isPwdConfirm: false,
    uploadedImage: false,
    modify_boolean: false,
    isPwdConfirmCode: false,

    loginStepper: 1,
    smallCardHeight: 0,
    height: 0,

    Login: {
      EmailID: "",
      Password: "",
      Phone_Number: "",
    },
    Password: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    sign_up: {
      user_name: "",
      user_email_id: "",
      phone_number: "",
    },
    selectedFile: {},
    SnackBarComponent: {},

    countryCodeItems: [
      { country_name: "India", country_code: "+91" },
      { country_name: "USA", country_code: "+1" },
    ],
  }),
  watch: {
    rememberme(val) {
      if (val == true) {
        localStorage.setItem("currentuseremail", JSON.stringify(this.Login));
      } else if (val == false) {
        delete localStorage.currentuseremail;
      }
    },
    loginStepper(newValue) {
      if (newValue === 4) {
        setTimeout(() => {
          this.focusOtpInput();
        }, 500);
      }
    },
  },
  computed: {
    currentTitle() {
      switch (this.loginStepper) {
        case 1:
          return "Sign In";
        case 2:
          return "Change Temporary Password";
        case 3:
          return "Forgot Password ?";
        case 4:
          return "Validate OTP";
        case 5:
          return "Sign Up";
      }
    },
  },
  mounted() {
    this.smallCardHeight = window.innerHeight - 680;
    this.height = window.innerHeight - 65;

    this.CheckRememberMe();
    this.checkRouteCondition();
  },
  methods: {
    focusOtpInput() {
      this.$nextTick(() => {
        const otpInputElement = this.$refs.otpInput.$el.querySelector("input");
        if (otpInputElement) {
          otpInputElement.focus();
        }
      }, 500);
    },

    checkRouteCondition() {
      let routeparam = this.$route.name.toLowerCase();
      switch (routeparam) {
        case "signup":
          this.loginStepper = 5;
          break;
        case "Signin":
          this.loginStepper = 1;
          break;
      }
    },
    async validateSignUpMethod() {
      const valid = await this.$refs.formSignUp.validate();
      if (valid.valid) {
        this.signUpMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Invalid Input",
        };
      }
    },
    async signUpMethod(key, file) {
      try {
        this.loading = true;
        let config = {
          method: "post",

          // url: "https://95nzp766ce.execute-api.us-east-1.amazonaws.com/user/signIn",
          url: "https://m4yvvvbv90.execute-api.us-east-1.amazonaws.com/prod/signup",
          data: JSON.stringify({
            user_name: this.sign_up.user_name,
            user_email_id: this.sign_up.user_email_id.toLowerCase(),
            // user_phone_number: this.sign_up.phone_number.trim(),
            user_image: this.imgSrc,
            command: "newUserSignUp",
          }),
          headers: {
            "Content-Type": "application/json",
          },
        };
        const result = await axios(config);

        console.log("result", result);

        if (result.data.data.status === 200) {
          console.log("result", result);
          this.loading = false;
          this.loginStepper = 1;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Account created Successfully",
          };
        }
      } catch (error) {
        this.loading = false;
        console.log("Bug", error);
      }
    },

    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    CheckRememberMe() {
      if (localStorage.getItem("currentuseremail") != null) {
        this.Login = JSON.parse(localStorage.getItem("currentuseremail"));
        this.rememberme = true;
      }
    },
    async ConfirmOTPMethod() {
      try {
        this.loadingLogin = true;
        await confirmSignIn({ challengeResponse: this.ConfirmOTP }).then(
          (res) => {
            this.SnackbarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              SnackbarText: "Login Successfull",
            };
            this.ActivateMethod();
            this.loadingLogin = false;
          },
        );
      } catch (error) {
        this.loadingLogin = false;
        console.log("OTP error", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.message,
        };
      }
    },
    async ValidateEnteredOTP() {
      const valid = await this.$refs.formConfirmOTP.validate();
      if (valid.valid) {
        this.ConfirmOTPMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Enter The Code Sent To Registered Email",
        };
      }
    },

    async SignIn() {
      try {
        this.loading = true;
        this.user = await signIn({
          username: this.Login.EmailID.trim(),
          options: {
            authFlowType: "CUSTOM_WITHOUT_SRP",
          },
        });
        // if (
        //   this.user.nextStep.signInStep ==
        //   "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
        // ) {
        //   this.SnackbarComponent = {
        //     SnackbarVmodel: true,
        //     SnackbarColor: "green",
        //     timeout: 2000,
        //     SnackbarText: `Verification OTP sent to ${this.Login.email_id.toLocaleLowerCase()}`,
        //   };

        if (
          this.user.nextStep.signInStep ==
          "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
        ) {
          this.loginStepper = 4;
          this.loading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "OTP Sent Successfully!!",
          };
          if (this.Login.EmailID != "") {
            this.$store.commit("SET_USEREMAIL", this.Login.EmailID);
          } else if (this.Login.Phone_Number != "") {
            this.$store.commit("SET_PHONENUMBER", this.Login.Phone_Number);
          }
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Invalid Credentials!!",
          };
          this.ActivateMethod();
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        if (error.message == "There is already a signed in user.") {
          this.loginLoader = true;
          await signOut({ global: true });
          this.SignIn();
        } else if (error.message == "User is disabled.") {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "You Are Currently Inactive",
          };
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: error.message,
          };
        }
      }
    },
    ActivateMethod() {
      this.$store.commit("SET_CURRENT_LOCATION", true);
      this.$store.commit("SET_LOCATION_ENABLED", false);
      setTimeout(() => this.$router.push("/LandingPage"), 500);
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "green",
        Top: true,
        SnackbarText: "Login Successful",
      };
    },

    async ValidateSignUpForm() {
      const valid = await this.$refs.form.validate();
      if (valid.valid) {
        this.SignIn();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Enter E-mail",
        };
      }
    },
  },
};
</script>

<style scoped>
.login-bg {
  min-height: 90vh;
  background: url("@/assets/PoliceImageLogin.png") center/cover no-repeat;
  position: relative;
  overflow: hidden;
}

/* overlay */
.login-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(31, 58, 104, 0.45); /* #1f3a68 overlay */
  z-index: 1;
}

/* keep content above overlay */
.login-bg > * {
  position: relative;
  z-index: 2;
}

.loginsmall_screen {
  min-height: 60vh;
  background: #1f3a68;
}

/* CENTER */
.login-wrapper {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  position: relative;
  width: 380px;
  padding: 32px;
  background: #ffffff;
  border-radius: 6px;
  border-top: 5px solid #d9a520; /* GOLD TOP STRIP */
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
}

/* TEXT */
.title-text {
  font-size: 22px;
  font-weight: 600;
  color: #1f3a68;
  letter-spacing: 0.6px;
}

.input-label {
  font-size: 13px;
  font-weight: 500;
}

/* BUTTON */
.login-btn {
  background: #1f3a68;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

/* FOOTER */
.footer-text {
  position: absolute;
  bottom: 14px;
  width: 100%;
  text-align: center;
  font-size: 11px;
  color: #cfd6e6;
}

.link {
  cursor: pointer;
  color: #1f3a68;
  font-weight: 500;
}
</style>
